<template>
  <section class="cartas-wrapper">
    <div class="cartas-grid">
      <div
        v-for="(item, index) in cartas"
        :key="index"
        class="stat-card"
        :class="{ 'stat-card-clickable': item.accion }"
        @click="item.accion && item.accion()"
      >
        <div class="stat-top">
          <div class="stat-icon">
            <v-icon size="18" color="#F2F2ED">{{ item.icono }}</v-icon>
          </div>
        </div>
        <div class="stat-value">{{ item.total }}</div>
        <div class="stat-label">{{ item.nombre }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CartasPersonalizadas",
  props: ["cartas"],
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&display=swap');

.cartas-wrapper {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

  font-family: var(--font-body);
}

.cartas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
}

.stat-card {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 18px;
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.stat-card-clickable {
  cursor: pointer;
}

.stat-card-clickable:hover {
  border-color: #5C5C62;
  transform: translateY(-2px);
}

.stat-top {
  margin-bottom: 14px;
}

.stat-icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-value {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12.5px;
  color: var(--text-secondary);
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/CartasPersonalizadas.vue